import { createClient } from '@supabase/supabase-js'

// aircargomcp shares the Navo24 (TrackingMCP) Supabase project with the rest of the family, so the
// identity store (auth.users) is the same: one Navo24 account signs in here AND on trackingmcp /
// schedulesmcp / loadingmcp / freightratesmcp — no separate signup, no migration.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string
const SUPABASE_ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// A missing URL/key must NEVER crash the SPA. The public pages (home tracker / developers / usage /
// contact / legal) don't use Supabase at all — but createClient THROWS on an empty url
// ("supabaseUrl is required"), which would take down the whole app at module load. Fall back to a
// syntactically-valid placeholder so the client constructs; only auth pages (login/dashboard) need
// the real VITE_SUPABASE_* to actually work.
export const hasSupabaseConfig = Boolean(SUPABASE_URL && SUPABASE_ANON)
if (!hasSupabaseConfig) {
  console.warn(
    '[supabase] VITE_SUPABASE_URL/ANON_KEY not set; auth disabled, public pages unaffected',
  )
}

export const supabase = createClient(
  SUPABASE_URL || 'https://placeholder.supabase.co',
  SUPABASE_ANON || 'public-anon-placeholder',
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } },
)

export const API_BASE = (import.meta.env.VITE_API_BASE as string) ?? 'https://api.aircargomcp.com'

/** Authenticated fetch against the aircargo API using the current Supabase session JWT. */
export async function apiFetch(path: string, init: RequestInit = {}) {
  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {}),
    },
  })
  const json = await res.json().catch(() => ({}))
  return { ok: res.ok, status: res.status, json }
}
